import { render, staticRenderFns } from "./fault_item.vue?vue&type=template&id=3feda36d"
import script from "./fault_item.vue?vue&type=script&lang=js"
export * from "./fault_item.vue?vue&type=script&lang=js"
import style0 from "./fault_item.vue?vue&type=style&index=0&id=3feda36d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports